export const STATUS_DONE = 'Done'
export const STATUS_NOT_STARTED = 'Not Started'
/** Em dash — used when lesson-instructor role is not set */
export const STATUS_NA = '\u2014'

/**
 * DWB report: Done / Not Started from LMS counts; em dash when LMS sends
 * `null` (no registration for that track).
 */
export function dwbTrainingCompletionStatus(count, total) {
  if (count === null) {
    return STATUS_NA
  }
  const n = count === undefined ? 0 : count
  if (n >= total) {
    return STATUS_DONE
  }
  return STATUS_NOT_STARTED
}

/**
 * K–8 core report: `n/total` fraction, or em dash when the user has no
 * lesson-instructor preference set (`teachesLessons` undefined).
 */
export function coreCompletionFraction(count, total, teachesLessonsDefined) {
  if (!teachesLessonsDefined) {
    return STATUS_NA
  }
  const n = count === undefined || count === null ? 0 : count
  return `${n}/${total}`
}
